<template>
  <el-dialog title="自动去重" :visible.sync="visible" width="552px" :append-to-body="true" center>
    <div class="fix-form">
      <!-- {{ autoDeduplicationSettings }} -->
      <div class="title-con">
        <div class="label-title">1.同一审批人在流程中多次出现时，自动去重</div>
        <el-switch v-model="autoDeduplicationSettings.sameApproverMultipleTimes.enable" active-color="#00B498" inactive-color="#E4F7F4"></el-switch>
      </div>
      <el-radio-group v-model="autoDeduplicationSettings.sameApproverMultipleTimes.strategy" class="check-group">
        <el-radio label="keepFirst"><span class="name-text">在流程中出现多次时，仅保留第一个</span></el-radio>
        <el-radio label="deduplicateConsecutive"><span class="name-text">仅在连续出现时，自动去重</span></el-radio>
      </el-radio-group>
      <div class="title-con">
        <div class="label-title">2.审批人和发起人是同一个人，审批自动通过</div>
        <el-switch v-model="autoDeduplicationSettings.approverIsInitiator" active-color="#00B498" inactive-color="#E4F7F4"></el-switch>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "autoFixRepeat",
  data() {
    return {
      visible: false,
      canFix:false,
      radio:2,
      autoPass:false,
      autoDeduplicationSettings:{...this.$store.state.design.settings.autoDeduplicationSettings}
    }
  },

  created() {
    // this.autoDeduplicationSettings = this.$deepCopy(this.$store.state.design.settings.autoDeduplicationSettings)
  },
  methods: {
    show() {
      this.visible = true
      this.autoDeduplicationSettings = this.$deepCopy(this.$store.state.design.settings.autoDeduplicationSettings)
    },
    save() {
      let data1 ={
        key:'approverIsInitiator',
        value:this.autoDeduplicationSettings.approverIsInitiator
      }
      this.$store.commit("updateProAutoDedup",data1);
      let data2 = {
        key:'sameApproverMultipleTimes',
        value:this.autoDeduplicationSettings.sameApproverMultipleTimes
      }
      this.$store.commit("updateProAutoDedup",data2);
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog--center .el-dialog__body{
  padding: 10px 32px 20px;
}
.fix-form{
  .title-con{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .label-title{
    font-weight: bold;
    font-size: 14px;
    color: #2F3030;
    margin-bottom: 2px;
  }
  /deep/.check-group{
    margin-bottom: 20px;
  }
  /deep/.el-radio{
    display: block;
    line-height: 34px;
    .name-text{
      color: #606266;
    }
  }
}
</style>
